<template>
  <WdsText>
    <WdsStack gap-sm direction-column>
      <WdsSelect
        v-model="selectedAccounts"
        multi-select
        searchable
        :label="meta.filter.quickFilter ? '' : $t('Accounts')"
        :list="accountsStore.accounts"
        :placeholder="$t('Select the accounts')"
        max-labels-visible="5"
        can-deselect
        labels-primary
      >
        <template #option="{ option }">
          <WdsStack gap-sm>
            <WdsAvatar xs :initials="option.name" :path="option.avatarPath" />
            <WdsText tertiary>{{ option.name }}</WdsText>
          </WdsStack>
        </template>
      </WdsSelect>
      <WdsCheckbox :checked="allChecked" @update:checked="toggleAccounts">
        {{ $t('Select all accounts') }}
      </WdsCheckbox>
      <WdsText secondary>
        {{ $t('Select the accounts you need to gather data from.') }}
      </WdsText>
    </WdsStack>
  </WdsText>
</template>

<script setup lang="ts">
// This component is handles filters for accounts that the user has access to.
import { WdsAvatar, WdsCheckbox, WdsSelect, WdsStack, WdsText } from '@worksome/wds-components'
import { computed, watch } from 'vue'
import { $t } from '@/composables/translation'
import {
  AccountStoreType,
  useAccountsStore,
} from '@/components/GraphqlDataTable/filters/accounts/accounts-store'
import { FilterMetaDataProp } from '@/components/GraphqlDataTable/filters/types'

defineProps<{ meta: FilterMetaDataProp }>()

const accountsStore = useAccountsStore()

const selectedAccounts = defineModel<AccountStoreType[]>({ default: () => [] })

const allChecked = computed(
  () =>
    selectedAccounts.value?.length === accountsStore.accounts?.length &&
    !!selectedAccounts.value?.length,
)

const toggleAccounts = (event: boolean) => {
  // If 'event' is true, select all accounts; otherwise, deselect all
  selectedAccounts.value = event ? accountsStore.accounts : []
}

// Currently we are the ones who update the store
watch(selectedAccounts, () => {
  accountsStore.selectedAccounts = selectedAccounts.value
})
</script>
